import * as React from 'react';

const SvgOutlookCalendar = (props) => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_118_1264)">
      <path
        d="M29.5076 10.2327V19.4777L32.7384 21.512C32.8236 21.5369 33.0082 21.5387 33.0934 21.512L46.9982 12.1374C46.9982 11.0279 45.9633 10.2327 45.3793 10.2327H29.5076Z"
        fill="#0072C6"
      />
      <path
        d="M29.5076 22.9262L32.4561 24.9517C32.8715 25.257 33.3721 24.9517 33.3721 24.9517C32.8733 25.257 47 15.8735 47 15.8735V32.8654C47 34.7151 45.816 35.4908 44.4846 35.4908H29.5058V22.9262H29.5076Z"
        fill="#0072C6"
      />
      <path
        d="M14.2412 18.6643C13.2365 18.6643 12.4359 19.1365 11.8447 20.0791C11.2536 21.0217 10.9572 22.2697 10.9572 23.8229C10.9572 25.3993 11.2536 26.6454 11.8447 27.5614C12.4359 28.4792 13.2116 28.9354 14.1702 28.9354C15.159 28.9354 15.9436 28.4898 16.5223 27.5987C17.101 26.7076 17.3921 25.4703 17.3921 23.8886C17.3921 22.2395 17.1116 20.956 16.5489 20.0383C15.9862 19.1223 15.2175 18.6643 14.2412 18.6643Z"
        fill="#0072C6"
      />
      <path
        d="M0.25293 5.53715V41.706L27.7679 47.4753V0.21167L0.25293 5.53715ZM18.6649 29.7361C17.5022 31.2663 15.9862 32.0332 14.1152 32.0332C12.2921 32.0332 10.808 31.2912 9.6595 29.8089C8.51275 28.3249 7.9376 26.3935 7.9376 24.0112C7.9376 21.4958 8.51985 19.4615 9.68613 17.9082C10.8524 16.355 12.3968 15.5775 14.3193 15.5775C16.1353 15.5775 17.6051 16.3195 18.7252 17.8071C19.8471 19.2946 20.4081 21.2544 20.4081 23.6882C20.4099 26.1894 19.8276 28.2059 18.6649 29.7361Z"
        fill="#0072C6"
      />
    </g>
    <defs>
      <clipPath id="clip0_118_1264">
        <rect
          width={46.7471}
          height={47.2636}
          fill="white"
          transform="translate(0.25293 0.21167)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgOutlookCalendar;
